import { signInToFirebase } from "@/Context/api";
import { useQuery } from "@tanstack/react-query";

const useSignInToFirebase = (userId: string) => {
  const query = useQuery({
    queryKey: ["firebase-sign-in", userId],
    queryFn: () => signInToFirebase(userId),
    refetchOnWindowFocus: false,
    enabled: !!userId
  });

  return query;
}

export default useSignInToFirebase;